import { AxiosPromise } from 'axios';
import { IUpdateCommand } from '../form';
import { instance } from '../../../../services/api';

const updateLocalGroupMemberDetails = (data: IUpdateCommand): AxiosPromise =>
  instance.put(`api/localGroupMemberDetails/${data.groupId}/${data.fileId}`, data);

export default updateLocalGroupMemberDetails;
